export default "__VITE_ASSET__DHGTjtUS__"